<div #wrapper class="wrapper">
    <i class="ti-calendar" (click)="toggle($event)">
        <div class="day-indicator">{{ day }}</div>
    </i>

    <span (click)="toggle($event)">{{ dayString | localise }}, {{ date | date: 'dd.MM.yyyy' }}</span>
</div>

<div class="datepicker-wrapper" #datepicker></div>
